import React from "react";

const BusinessProposalHeader: React.FC = () => {
  return (
    <header className="bg-white border-b border-gray-100 shadow-sm">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <img
            src="/Glossa-Logo-1.png"
            alt="Glossa"
            className="h-8 sm:h-9 w-auto object-contain"
            onError={(e) => {
              (e.target as HTMLImageElement).src = "/logo.svg";
            }}
          />
          <div className="hidden sm:block h-6 w-px bg-gray-200" />
          <span className="hidden sm:block text-sm font-semibold text-[#402B69] truncate">
            Business Onboarding
          </span>
        </div>
        <a
          href="https://getglossa.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs sm:text-sm font-medium text-[#885ABB] hover:text-[#7647a8] transition-colors whitespace-nowrap"
        >
          Powered by Glossa
        </a>
      </div>
    </header>
  );
};

export default BusinessProposalHeader;
